import React from 'react';
import { Typography } from 'antd';
import { createHouseAddress } from '../../../../../shared/packages/address';

const ChildList = ({ roomData, currentHouseId }) => {
  return (
    <div>
      <Typography.Text>
        {roomData.typeName} {roomData.flat} {createHouseAddress(roomData)}
      </Typography.Text>

      <ul>
        {roomData.relatedRooms.map((room) => {
          return (
            <li key={room.id}>
              {room.typeName} {room.flat}{' '}
              {room.houseId === currentHouseId ? (
                <Typography.Text type="danger">
                  удалится из связки
                </Typography.Text>
              ) : (
                createHouseAddress(room)
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ChildList;
